module.exports = __webpack_public_path__ + "static/media/cardcase.1cc99329.png";